import { UserModel } from '../../../../models/user.model'

export class OriginModel {
  id: string
  name: boolean
  description: any
  created_by: UserModel
  created_on: any

  // constructor(origin)
  // {
  //   {
  //     this.id = origin.id;
  //     this.name = origin.name;
  //     this.description = origin.description;
  //     this.created_by = new UserModel(origin.created_by);
  //     this.created_on = new Date(origin.created_on);
  //   }
  // }
}



// WEBPACK FOOTER //
// ./src/app/main/content/system/origins/models/origin.model.ts